import { OnboardingStep } from 'further-types/lp/onboarding';
import { match } from 'ts-pattern';
import PreviousInvestorClassifications from './PreviousInvestorClassifications';
import PreviousTaxDeclarations from './PreviousTaxDeclarations';
import PreviousKycOrKybDetails from './PreviousKycOrKybDetails';

type Props = {
  vehicleId: string;
  vehicleApplicationId: string;
  step: OnboardingStep;
};

const PreviousResults: React.FC<Props> = ({
  vehicleId,
  vehicleApplicationId,
  step,
}) => {
  return match(step)
    .with(OnboardingStep.TaxDeclarations, () => (
      <PreviousTaxDeclarations
        vehicleId={vehicleId}
        vehicleApplicationId={vehicleApplicationId}
      />
    ))
    .with(OnboardingStep.InvestorClassification, () => (
      <PreviousInvestorClassifications
        vehicleId={vehicleId}
        vehicleApplicationId={vehicleApplicationId}
      />
    ))
    .with(OnboardingStep.KYCOrKYB, () => (
      <PreviousKycOrKybDetails
        vehicleId={vehicleId}
        vehicleApplicationId={vehicleApplicationId}
      />
    ))
    .otherwise(() => null);
};

export default PreviousResults;
